import {SxType} from "@baseTypes/sx/sxTypes";

/**
 * Two ways to end the work, as two rows of equal weight.
 *
 * Both are the app's own blue, like every other button in it. Which outcome a
 * row carries is said in its words, and an 8px dot repeats it in the same colour
 * the stop pips use, so the rows are still told apart at a glance. The colour
 * used to be in the label: a green row above a red one, which reads as "safe"
 * and "dangerous" when both are ordinary outcomes, and matched nothing else on
 * the screen. Colour belongs to state here, never to an action.
 */
const decision: SxType = {
    justifyContent: 'flex-start',
    gap: '8px',
    width: '100%',
    minHeight: '32px',
    padding: '4px 10px',
    fontSize: '12px',
    fontWeight: 600,
    textTransform: 'none',
    border: 'none',
    backgroundColor: 'transparent',
    borderRadius: '6px',
    color: 'primary.main',
    '&::before': {
        content: '""',
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        flexShrink: 0,
    },
    '&:hover': {
        border: 'none',
        backgroundColor: 'action.hover',
    },
    '&.Mui-disabled': {
        border: 'none',
        color: 'text.disabled',
        '&::before': {backgroundColor: 'text.disabled'},
    },
}

export const decisionSx: SxType = {
    done: {
        ...decision,
        '&::before': {...decision['&::before'], backgroundColor: 'success.main'},
    },
    failed: {
        ...decision,
        '&::before': {...decision['&::before'], backgroundColor: 'error.main'},
    },
}

export const sx: SxType = {
    panel: {
        padding: '6px 4px 4px',
        gap: 0,
        minWidth: '180px',
        maxWidth: '260px',
    },
    /** Which task you are acting on - the panel opens over a dense list. */
    panelTitle: {
        fontSize: '11px',
        fontWeight: 700,
        padding: '0 10px 5px',
        color: 'text.secondary',
    },
    panelExtra: {
        padding: '4px 6px 2px',
    },
    panelExtraLabel: {
        fontSize: '11px',
        color: 'text.secondary',
        marginRight: 'auto',
    },
    /** Quiet until wanted: reading the panel is the common case, acting is not. */
    trigger: {
        opacity: 0.45,
        transition: 'opacity .15s',
        '&:hover, &:focus-visible': {opacity: 1},
    },
}
